import { Calculator, Combine, ClipboardList, Table2, IndianRupee, ScrollText, FileText, Boxes, MessageSquareText } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/store/AuthStore";

const TABS = [
  { id: "calc", label: "CALC", Icon: Calculator },
  { id: "assembly", label: "ASSEMBLY", Icon: Combine },
  { id: "order", label: "ORDER", Icon: ClipboardList },
  { id: "costing", label: "COSTING", Icon: IndianRupee },
  { id: "rate", label: "RATE", Icon: ScrollText },
  { id: "rate88", label: "RATE 8.8", Icon: FileText },
  { id: "import", label: "IMPORT", Icon: MessageSquareText },
  { id: "stock", label: "STOCK", Icon: Boxes },
  { id: "tables", label: "TABLES", Icon: Table2 },
];

export function BottomNav({ active, onChange }) {
  const { user } = useAuth();
  const allowed = !user
    ? TABS.filter((t) => t.id === "calc")
    : user.role === "admin"
      ? TABS
      : TABS.filter((t) => (user.permissions || TABS.map((x) => x.id)).includes(t.id));
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-800 bg-[#090D16]/95 backdrop-blur-xl">
      <div className="mx-auto grid max-w-3xl" style={{ gridTemplateColumns: `repeat(${allowed.length}, minmax(0, 1fr))` }}>
        {allowed.map(({ id, label, Icon }) => {
          const on = active === id;
          return (
            <button
              key={id}
              data-testid={`nav-tab-${id}`}
              onClick={() => onChange(id)}
              className={cn(
                "relative flex flex-col items-center gap-1 py-2.5 transition-colors",
                on ? "text-orange-400" : "text-slate-500 hover:text-slate-300"
              )}
            >
              {on && <span className="absolute top-0 h-0.5 w-10 rounded-full bg-orange-500" />}
              <Icon className={cn("h-5 w-5 transition-transform", on && "scale-110")} strokeWidth={2.2} />
              <span className="text-[10px] font-bold tracking-wide">{label}</span>
            </button>
          );
        })}
      </div>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
